"use client"
import { createContext, useContext, useState } from "react";

export const Sons = createContext(undefined);

export function ThemeProvider({ children }) {
    const [consultationData, setConsultationData] = useState([]);
    const [tempData, setTempData] = useState([]);

    return (
        <Sons.Provider value={[
            consultationData,
            setConsultationData
        ]}>{children}</Sons.Provider>
    );
}

export function useThemeContext() {
    return useContext(Context);
}